import PropTypes from 'prop-types';
import React from 'react';
import ReactModal from 'react-modal';
import useStyles from './Modal.styles';

const Modal = ({ children }) => {
  const classes = useStyles();

  return (
    <ReactModal className={classes.modal} overlayClassName={classes.overlay} isOpen>
      {children}
    </ReactModal>
  );
};

Modal.propTypes = {
  children: PropTypes.node.isRequired,
};

export default React.memo(Modal);
